import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import { SourceChangeTabPanel } from "@/screens/Dashboard/components/SourceChangeTabPanel"

export const Route = createFileRoute("/app/dashboard/_layout/pending-approvals/_layout/source-change")({
  search: {
    middlewares: [retainSearchParams(["taskViewScope"])],
  },
  component: () => <SourceChangeTabPanel />,
})
